import { render } from "./IconCenterFocusStrong.vue?vue&type=template&id=34bf6c5a"
import script from "./IconCenterFocusStrong.vue?vue&type=script&lang=js"
export * from "./IconCenterFocusStrong.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__